
export default {
  name: 'FlowUnordered',

  props: {
    items: Array,
    current: {
      type: Number,
      default: 0
    }
  }
}
